import { Box, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import Arrow from '../../../assets/svg/arrow.svg';
import ConfideLogoWhite from '../../../assets/svg/confideLogoWhite.svg';

interface CustomerQuickStartProps {
  screenNum: number;
}

const CustomerQuickstartComponent = ({
  screenNum,
}: CustomerQuickStartProps) => {
  return (
    <Stack
      flexBasis='35%'
      sx={{
        background: 'linear-gradient(270deg, #00CECF 0%, #2449FC 100%)',
        height: '100vh',
        padding: '105px 82px',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Schibsted Grotesk, sans-serif',
          color: '#FFFFFF',
          fontSize: '20px',
          fontWeight: 500,
          lineHeight: '125%',
        }}
      >
        <FormattedMessage defaultMessage='Welcome to' />
      </Typography>
      <Box
        component='img'
        src={ConfideLogoWhite}
        sx={{
          maxWidth: '338px',
          width: '80%',
          height: 'auto',
          marginTop: '30px',
          marginBottom: '100px',
        }}
      />
      <Typography
        sx={{
          fontFamily: 'Schibsted Grotesk, sans-serif',
          color: '#FFFFFF',
          fontSize: '28px',
          fontWeight: 500,
          lineHeight: '125%',
        }}
      >
        <FormattedMessage defaultMessage='Synonymise your Organisation with Integrity, Trust and Accountability.' />
      </Typography>
      <Stack direction='row' alignItems='center' gap={1} marginTop='20px'>
        {screenNum >= 3 && (
          <Typography
            sx={{
              fontFamily: 'Schibsted Grotesk, sans-serif',
              color: '#FFFFFF',
              fontSize: '20px',
              fontWeight: 500,
              lineHeight: '125%',
            }}
          >
            <FormattedMessage defaultMessage='You are almost there!' />
          </Typography>
        )}
        <Box
          component='img'
          src={Arrow}
          sx={{
            width: '100px',
          }}
        />
      </Stack>
    </Stack>
  );
};

export default CustomerQuickstartComponent;
